import { RecentlyViewed } from '@theme/recently-viewed-products';
import { morphSection, sectionRenderer } from '@theme/section-renderer';

/**
 * @returns {string}
 */
function getSearchUrl() {
  return typeof Theme !== 'undefined' && Theme?.routes?.search_url ? Theme.routes.search_url : '/search';
}

/**
 * @param {HTMLElement} sectionRoot
 */
async function hydrateRecentlyViewed(sectionRoot) {
  const sectionId = sectionRoot.dataset.sectionId;
  if (!sectionId) return;

  const shopifySection = sectionRoot.closest('.shopify-section');
  const hideWhenEmpty = sectionRoot.dataset.hideWhenEmpty === 'true';

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    return;
  }

  const maxProductsRaw = sectionRoot.dataset.maxProducts;
  const maxProducts = Math.min(
    24,
    Math.max(1, Number.parseInt(String(maxProductsRaw || '16'), 10) || 16)
  );
  const ids = RecentlyViewed.getProducts().slice(0, maxProducts);
  if (!ids.length) {
    if (hideWhenEmpty && shopifySection instanceof HTMLElement) {
      shopifySection.hidden = true;
      shopifySection.setAttribute('aria-hidden', 'true');
    }
    return;
  }

  if (shopifySection instanceof HTMLElement) {
    shopifySection.hidden = false;
    shopifySection.removeAttribute('aria-hidden');
  }

  const url = new URL(getSearchUrl(), location.origin);
  url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('resources[type]', 'product');

  try {
    const html = await sectionRenderer.getSectionHTML(sectionId, false, url);
    await morphSection(sectionId, html);
  } catch {
    /* Section Rendering pode falhar em edge cases; mantém placeholders */
  }
}

function init() {
  document.querySelectorAll('[data-recently-viewed-product-list]').forEach((el) => {
    if (el instanceof HTMLElement) hydrateRecentlyViewed(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
